<mat-form-field [ngClass]="{'empty-required': isRequired && (val == null || val == '') }" appearance="outline" style="width: 100%">

  <mat-label [ngClass]="{ hide: label == 'hide' }" [ngClass]="{'empty-required': isRequired && (val == null || val == '') }" >
      {{ label }}<span *ngIf="isRequired == true"> ★</span>
  </mat-label>
  
  <mat-select *ngIf="isGeneral" [(value)]="val" (selectionChange)="selectItem($event)" id="{{id}}" >
    <mat-option [disabled]="item.disabled" [value]="item.value" *ngFor="let item of dropdownList">{{ item.display }}</mat-option>
  </mat-select>

  <mat-select *ngIf="isJoinType" [disabled]="disableJoinTypeDropdown" [(value)]="val" (selectionChange)="selectItem($event)" id="{{id}}" >
    <mat-option [disabled]="item.disabled" [value]="item.value" *ngFor="let item of dropdownList">{{ item.display }}</mat-option>
  </mat-select>

  <mat-select *ngIf="isReason" [(value)]="val" (selectionChange)="selectItem($event)" id="{{id}}" >
    <mat-option [disabled]="item.disabled" [value]="item.value" *ngFor="let item of dropdownList">{{ item.display }}</mat-option>
  </mat-select>

  <mat-select *ngIf="isWorkerUsername && isManageWorkOrderReason == false" [(value)]="val" (selectionChange)="selectItem($event)" id="{{id}}" >
    <mat-option [disabled]="item.disabled" [value]="item.value" *ngFor="let item of dropdownList">{{ item.display }}</mat-option>
  </mat-select>

  <mat-select *ngIf="isManageWorkOrderReason && isWorkerUsername == false" [disabled]="disableActivityDropdown" [(value)]="val" (selectionChange)="selectItem($event)" id="{{id}}" >
    <mat-option [disabled]="item.disabled" [value]="item.value" *ngFor="let item of dropdownList">{{ item.display }}</mat-option>
  </mat-select>

  <mat-select *ngIf="isActivity" [disabled]="disableActivityDropdown" [(value)]="val" (selectionChange)="selectItem($event)" id="{{id}}" >
    <mat-option [disabled]="item.disabled" [value]="item.value" *ngFor="let item of dropdownList">{{ item.display }}</mat-option>
  </mat-select>

  <mat-select *ngIf="isAssessment || isRegion" [(value)]="val" (selectionChange)="selectItem($event)" id="{{id}}" >
    <mat-option [disabled]="item.disabled" [value]="item.value" *ngFor="let item of dropdownList">{{ item.display }}</mat-option>
  </mat-select>

  <mat-select *ngIf="isQueryReport" [(value)]="val" (selectionChange)="selectItem($event)" id="{{id}}">
    <mat-option [disabled]="item.disabled" [value]="item.value" *ngFor="let item of dropdownList">{{ item.display }}</mat-option>
  </mat-select>

  <mat-select *ngIf="isQueryReportFormat" [(value)]="val" (selectionChange)="selectItem($event)" id="{{id}}" >
    <mat-option [disabled]="item.disabled" [value]="item.value" *ngFor="let item of dropdownList">{{ item.display }}</mat-option>
  </mat-select>

  <mat-select *ngIf="isCrewManagement" [(value)]="val" (selectionChange)="selectItem($event)" id="{{id}}" >
    <mat-option [disabled]="item.disabled" [value]="item.value" *ngFor="let item of dropdownList">{{ item.display }}</mat-option>
  </mat-select>

  <div class="dropdown-icons">
    <mat-icon variant="outlined" class="material-icons-outlined" style="line-height: 1.25; font-size: 18px; text-align: center" *ngIf="tooltip != null && tooltip != ''" matSuffix [matTooltip]="tooltip">info</mat-icon>
  </div>

</mat-form-field>
